// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__23w7y","expandIconWrapper":"CustomNode_expandIconWrapper__1xz5V","isOpen":"CustomNode_isOpen__jZmCP","labelGridItem":"CustomNode_labelGridItem__24MoC"};